(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lsc-header-assets"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-lsc-phone-link]');
    if (!link) return;
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish('lsc:phone_click', { location: link.getAttribute('data-lsc-phone-link') });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
